import { TranslationKey } from 'state/intl/types';

export const geographicalFeeLabelIdMap: Record<string, TranslationKey> = {
  CO: 'geographicalFeeCO',
};

export const isMappedGeographicalFeeState = (
  state?: string | null
): state is keyof typeof geographicalFeeLabelIdMap => {
  return !!state && Object.prototype.hasOwnProperty.call(geographicalFeeLabelIdMap, state);
};
